import { render, staticRenderFns } from "./State.vue?vue&type=template&id=2c108320&scoped=true"
import script from "./State.vue?vue&type=script&lang=js"
export * from "./State.vue?vue&type=script&lang=js"
import style0 from "./State.vue?vue&type=style&index=0&id=2c108320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c108320",
  null
  
)

export default component.exports